import * as R from 'ramda';

import {getCampaignWorkflow} from 'js/common/workflows';

const {CampaignDisplayType, CampaignObjective} = window.sn.enums;

export const isCampaignContentGeneric = R.pipe(
    getCampaignWorkflow,
    R.prop('genericContent')
);

export const isCampaignPreApproval = R.pipe(
    getCampaignWorkflow,
    R.prop('requiresPreapproval')
);

export const isCampaignContentOnly = R.pipe(
    getCampaignWorkflow,
    R.prop('contentOnly')
);

export const PRICINGS = {
    CPCC_IMAGE: [500, 750, 1000, 1250],
    CPCC_VIDEO: [500, 750, 1000, 1250],
    CPE_IMAGE: [0.3, 0.4, 0.45, 0.5],
    CPE_VIDEO: [0.3, 0.4, 0.45, 0.5]
};

export const CAMPAIGN_PRICING_MODELS = {
    image: {
        [CampaignObjective.SOCIAL_ENGAGEMENT]: {
            cost: PRICINGS.CPE_IMAGE,
            engagements_or_content_created: PRICINGS.CPCC_IMAGE
        },
        [CampaignObjective.CONTENT_CREATION]: {
            cost: PRICINGS.CPCC_IMAGE,
            engagements_or_content_created: PRICINGS.CPE_IMAGE
        }
    },
    video: {
        [CampaignObjective.SOCIAL_ENGAGEMENT]: {
            cost: PRICINGS.CPE_VIDEO,
            engagements_or_content_created: PRICINGS.CPCC_VIDEO
        },
        [CampaignObjective.CONTENT_CREATION]: {
            cost: PRICINGS.CPCC_VIDEO,
            engagements_or_content_created: PRICINGS.CPE_VIDEO
        }
    }
};

export const VIDEO_OR_IMAGE_CAMPAIGN = {
    [CampaignDisplayType.INSTAGRAM_IMAGE]: 'image',
    [CampaignDisplayType.INSTAGRAM_VIDEO]: 'video',
    [CampaignDisplayType.SNAPCHAT_VIDEO]: 'video',
    [CampaignDisplayType.TWITTER_IMAGE]: 'image',
    [CampaignDisplayType.YOUTUBE_VIDEO]: 'video',
    [CampaignDisplayType.PINTEREST_IMAGE]: 'image',
    [CampaignDisplayType.PINTEREST_VIDEO]: 'video'
};

export const DEFAULT_PRICING_MODEL = {
    cost: PRICINGS.CPE_IMAGE,
    engagements_or_content_created: PRICINGS.CPCC_IMAGE
};

export const DefaultInterests = [
    'Beauty',
    'DIY',
    'Entertainment',
    'Family',
    'Fashion',
    'Fitness',
    'Food',
    'Lifestyle',
    'Pets',
    'Photography',
    'Social Good',
    'Travel'
];

export const isShippingProduct = R.propEq('influencer_compensation_type', 'product_payment');



// WEBPACK FOOTER //
// ./common/campaign_helper.js